import React from 'react';
import { Link } from 'react-router-dom';
import FadeInImage from '../components/FadeInImage';
import ContentLayout from '../layout/ContentLayout';
import './InteractiveMusicPage.css';

function InteractiveMusicPage() {
	return (
		<ContentLayout contentHeader={'Interactive Music Performances'}>
			<FadeInImage
				src='/live.jpg'
				className='liveImage'
				alt='Interactive live music performance'
			/>
			<p className='content-paragraph'>
				As a music therapist and professional musician, I offer interactive music
				performances designed especially for primary schools and special
				educational settings. These sessions are grounded in high-quality
				musicianship and a deep understanding of children’s emotional, social,
				and developmental needs.
			</p>

			<h3 className='pianoPricingHeading'>What to Expect?</h3>
			<ul className='pianoList'>
				<li>
					Live acoustic music played on traditional instruments such as fiddle,
					banjo, mandolin, double bass, guitar.
				</li>
				<li>
					Interactive songs and rhythms that invite children to sing, move, and
					join in.
				</li>
				<li>
					Old-time and folk-inspired music celebrating community, history, and
					shared experience.
				</li>
				<li>
					Adaptable sessions tailored for different ages, abilities, and sensory
					needs.
				</li>
				<li>A focus on connection, inclusion, and joy through music.</li>
			</ul>

			<h3 className='pianoPricingHeading'>Why choose interactive live music?</h3>
			<p className='content-paragraph'>
				Live acoustic music creates an atmosphere that recordings can’t
				replicate. Children experience sound vibrations, rhythm, and melody in
				real time — supporting attention, communication, coordination, and
				emotional expression.
			</p>
			<p className='content-paragraph'>
				With my background in music therapy, I ensure every performance is
				sensitive to group dynamics and inclusive of all participants.
			</p>

			<p className='content-paragraph'>
				I'm lucky to work with incredibly talented musicians. Find out more about our <Link to='/performances/meet-the-team' className='contact-link'>team</Link>, and read <Link to='/testimonials' className='contact-link'>testimonials</Link> from the people we have supported.
			</p>

			<h3 className='pianoPricingHeading'>Format & Booking</h3>
			<p className='content-paragraph'>Sessions can be offered as:</p>
			<ul className='pianoList'>
				<li>30–60 minute interactive performances</li>
				<li>
					Themed music sessions linked to curriculum topics (e.g. folk tales,
					seasons, holidays)
				</li>
				<li>One-off workshops or whole-school enrichment days</li>
			</ul>

			<p className='content-paragraph'>
				Available for schools across South West/ South Wales. To discuss your
				school’s needs or request a quote, <Link to='/contact' className='contact-link'>please get in touch</Link>.
			</p>
		</ContentLayout>
	);
}

export default InteractiveMusicPage;
